module.exports = __webpack_public_path__ + "static/media/lots3.78b281f8.jpg";